import { createIcon } from '../icon'
import DeliveryNowIcon from '../svg/DeliveryNowIcon'

export const DeliveryNowIconDefault = createIcon(DeliveryNowIcon)
